import { useEffect, useState, useRef } from "react";

export default function Captcha({ onToken }) {
  const [cfg, setCfg] = useState(null);
  const containerRef = useRef(null);
  const scriptLoaded = useRef(false);

  useEffect(() => {
    // Fetch public config
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/security/captcha`;
    fetch(url).then(r => r.json()).then(setCfg).catch(() => setCfg({ enabled: false }));
  }, []);

  useEffect(() => {
    if (!cfg?.enabled || !cfg.site_key || scriptLoaded.current) return;
    const { provider, site_key } = cfg;
    let src = "";
    let cb = "";
    if (provider === "v2") src = "https://www.google.com/recaptcha/api.js?render=explicit";
    else if (provider === "v3") { cb = "onCaptchaLoadV3"; src = `https://www.google.com/recaptcha/api.js?render=${site_key}`; }
    else if (provider === "turnstile") src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";

    const existing = document.querySelector(`script[src="${src}"]`);
    const attach = () => {
      scriptLoaded.current = true;
      if (provider === "v2" && window.grecaptcha && containerRef.current) {
        window.grecaptcha.ready(() => {
          try {
            window.grecaptcha.render(containerRef.current, { sitekey: site_key, callback: onToken });
          } catch (_e) { /* widget already rendered */ }
        });
      } else if (provider === "v3" && window.grecaptcha) {
        window.grecaptcha.ready(() => {
          window.grecaptcha.execute(site_key, { action: "submit" }).then(onToken).catch(() => onToken(""));
        });
      } else if (provider === "turnstile" && window.turnstile && containerRef.current) {
        try { window.turnstile.render(containerRef.current, { sitekey: site_key, callback: onToken }); }
        catch (_e) { /* widget already rendered */ }
      }
    };
    if (existing) {
      const ready = provider === "turnstile" ? window.turnstile : window.grecaptcha;
      if (ready) attach(); else existing.addEventListener("load", attach, { once: true });
      return;
    }
    const s = document.createElement("script");
    s.src = src; s.async = true; s.defer = true; s.onload = attach;
    document.head.appendChild(s);
  }, [cfg, onToken]);

  if (!cfg?.enabled) return null;
  if (cfg.provider === "v3") return <div className="text-[10px] text-slate-400 text-center">Terlindungi reCAPTCHA v3</div>;
  return <div ref={containerRef} data-testid="captcha-widget" className="flex justify-center my-2"/>;
}
